import { render, staticRenderFns } from "./ChooseValue.vue?vue&type=template&id=3577ed40&scoped=true"
import script from "./ChooseValue.vue?vue&type=script&lang=js"
export * from "./ChooseValue.vue?vue&type=script&lang=js"
import style0 from "./ChooseValue.vue?vue&type=style&index=0&id=3577ed40&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3577ed40",
  null
  
)

export default component.exports